import React, {useEffect, useState} from 'react';
import {useTheme} from "../../../../common/ProjectThemeProvider";
import {checkNullStr, getCurrUrlParamValue, getJsonValue, isBoolTrue, isJsonValueTrue} from "../../../../common/fusion-ui/utils/ReactUtils";
import {printError, printLog, sendRequest} from "../../../utils/AppUtils";
import {useToast} from "../../../../common/fusion-ui/provider/ToastProvider";
import {Anchor} from "../../../../common/fusion-ui";
import {CssVariant, DefStrNA, Messages} from 'common/fusion-ui/config/FusionConfig';
import {GenRouteUrls, ModuleFieldsData, Modules, ReqUrls, ShowViewType} from "../../../config/AppConfig";
import {AppLinkPreview, InternalPageRoot} from "../../../index";

const Link_InternalPage = React.memo(({
                                          open,
                                          onHide,
                                          showAs = ShowViewType.PAGE,
                                      }) => {
    const TAG = "Link_InternalPage";

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const moduleName = Modules.UsefulLinks;
    const mf = ModuleFieldsData[moduleName];

    const Fields = {
        recordId: 'recordId',
        pageDataObject: 'pageDataObject',

        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',
        isDataFetched: 'isDataFetched',

        prevRecordId: 'prevRecordId',
        nextRecordId: 'nextRecordId',
    };

    const [fieldsData, setFieldsData] = useState({});

    useEffect(() => {
        const recordId = getCurrUrlParamValue('id');
        fetchPageData(recordId);
    }, []);

    return (<>
        <InternalPageRoot
            tag={TAG}
            moduleName={moduleName}
            title={getTabTitle()}
            backToListText={'Back to Links'}
            isDataFound={getField(Fields.isDataFound)}
            isDataLoading={getField(Fields.isDataLoading)}
            dataLoadingMsg={getField(Fields.dataLoadingMsg)}
            internalPageUrl={GenRouteUrls.link_internalPage}
            prevRecordId={getField(Fields.prevRecordId)}
            nextRecordId={getField(Fields.nextRecordId)}
            onPrev={() => fetchPageData(getField(Fields.prevRecordId), false)}
            onNext={() => fetchPageData(getField(Fields.nextRecordId), false)}
            open={open}
            onHide={onHide}
            showAs={showAs}>
            <div>
                <table className={'w-100x'} style={{color: theme.text}}>
                    <tbody>

                    {/* Updated by Vandit Tewari on (6/11/24) - in every tr given a class 'wmInternalPageTrBreak' done this bcz below 560px the text in some td getting out of screen as these both comes in same row - declared in fusion css also in all td added class text-break*/}
                    {/*title */}
                    
                    <tr className='wmInternalPageTrBreak'>
                        <th className={'text-nowrap flex-nowrap d-flex al-start jc-start'}>{mf.title.title}:</th>
                        <td className={'px-2 text-wrap text-break'}>{getPageField(mf.title, DefStrNA)}</td>
                    </tr>

                    {/*  desc */}
                    <tr className='wmInternalPageTrBreak'>
                        <th className={'text-nowrap flex-nowrap d-flex al-start jc-start'}>{mf.desc.title}:</th>
                        <td className={'px-2 text-wrap text-block text-break'}>{getPageField(mf.desc, DefStrNA)}</td>
                    </tr>

                    {/* url */}
                    <tr className='wmInternalPageTrBreak'>
                        <th className={'text-nowrap flex-nowrap d-flex al-start jc-start'}>{mf.url.titleAlt}:</th>
                        <td className={'px-2 text-wrap text-break'}>
                            {checkNullStr(getPageField(mf.url)) ? (
                                <Anchor
                                    href={getPageField(mf.url)}
                                    simple={true}
                                    target={'_blank'}>{getPageField(mf.url)}</Anchor>
                            ) : (
                                <span>{DefStrNA}</span>
                            )}
                        </td>
                    </tr>
                    </tbody>
                </table>

                {/*link-preview*/}
                <div className={'mt-1'}>
                    <AppLinkPreview url={getPageField(mf.url)}/>
                </div>

            </div>
        </InternalPageRoot>
    </>)


    //======================Request Functions start=====================
    async function fetchPageData(recordId, checkBefore = true) {
        const fun = 'fetchPageData:';
        if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isDataFetched))) {
            log(fun, 'recordId:', recordId);
            updateField(Fields.isDataFetched, true);
            updateField(Fields.recordId, recordId);
            if (checkNullStr(recordId)) {
                updateField(Fields.pageDataObject, {});
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, true);
                updateField(Fields.dataLoadingMsg, "");
                updateField(Fields.nextRecordId, null);
                updateField(Fields.prevRecordId, null);

                //send-request
                const REQUEST_OPTIONS = {
                    recordId: recordId,
                    getAdjacentRecordIds: true,
                };
                try {
                    sendRequest({
                        reqUrl: ReqUrls.link__addEditPage_fetch_editFormData,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const fetchedPageData = getJsonValue(fetchedData, 'data', {});
                            const success = isJsonValueTrue(fetchedData, 'success');
                            const message = getJsonValue(fetchedData, 'message');
                            const nextRecordId = getJsonValue(fetchedPageData, 'nextRecordId');
                            const prevRecordId = getJsonValue(fetchedPageData, 'prevRecordId');

                            if (success) {
                                // toast(message, CssVariant.success)
                                updateField(Fields.pageDataObject, fetchedPageData);
                                updateField(Fields.nextRecordId, nextRecordId);
                                updateField(Fields.prevRecordId, prevRecordId);
                                updateField(Fields.isDataFound, success);
                                updateField(Fields.isDataLoading, false);
                            } else {
                                toast(message, CssVariant.danger)
                                updateField(Fields.dataLoadingMsg, message);
                                updateField(Fields.isDataLoading, false);
                                updateField(Fields.isDataFound, false);
                            }
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            toast(Messages.fetchError, CssVariant.danger)
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                } catch (error) {
                    toast(Messages.fetchError, CssVariant.danger)
                    logErr(fun, error);
                    updateField(Fields.dataLoadingMsg, Messages.fetchError);
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                }
            } else {
                toast('Record-id not found!', CssVariant.danger);
                updateField(Fields.dataLoadingMsg, 'Record-id not found!');
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, false);
            }
        }
    }

    //======================Request Functions end=====================

    //======================Util Functions start=====================


    function getPageField(colField, defValue) {
        return getJsonValue(getField(Fields.pageDataObject), colField.column, defValue);
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function getTabTitle() {
        return `Useful Link Details`;
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default Link_InternalPage;
